import { render, staticRenderFns } from "./BuscarCedula.vue?vue&type=template&id=013869fb"
import script from "./BuscarCedula.vue?vue&type=script&lang=js"
export * from "./BuscarCedula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports